module.exports = __webpack_public_path__ + "static/Aishah-d718d1f2f2c4d57b7e14228094785de1.png";